import { createBrowserRouter } from "react-router";
import { trackInAppHistory } from "@/utils/inAppHistory";
import routes from "./routes";

const router = createBrowserRouter(routes);
trackInAppHistory(router);

export default router;
